<template>
  <el-dialog title="" 
    :visible.sync="dialogVisible" :custom-class="`ai-dialog-form writing ${'web_language_wm_dialog_' + $store.state.app.web_language_wm}`"  :before-close="beforeCloseHandler" @closed="closed"  append-to-body  :close-on-click-modal="false" width="762px" >
      <div slot="title" class="header_part">
        <span class="title">{{$t('components_ai_command_index_1954')}}</span>
      </div>
        <el-form @submit.native.prevent ref="dialogForm" :model="dialogForm" :label-position="labelPosition" :label-width="$store.state.app.web_language_wm == 'en' ? 'auto' : '95px'" :rules="dialogFormRules">       
          <el-form-item :label="$t('components_ai_command_tkd_1957')+this.typeTitle()+$t('components_ai_command_tkd_1958')" prop="keywords">
            <el-input
              :maxlength="100"
              show-word-limit              
              v-model="dialogForm.keywords"
              :placeholder="$t('components_ai_command_write_1984')"
              autocomplete="off">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('components_ai_command_tkd_1957')+this.typeTitle()+$t('components_ai_command_write_1985')" prop="subject">
              <el-tooltip class="item"  effect="light" :content="$t('components_ai_command_write_1986')" placement="right">
                <span class="subject_icon el-icon-warning-outline" :style="{left: $store.state.app.web_language_wm == 'en' ? '200px' : '120px'}"></span>
              </el-tooltip>
            <el-input
              :maxlength="150"
              show-word-limit                
              type="textarea"
              rows="3"
              :placeholder="$t('components_ai_command_tkd_1963')+'\n'+ $t('components_ai_command_write_1987')"
              v-model="dialogForm.subject"
              >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('components_ai_command_tkd_1957')+this.typeTitle()+$t('components_ai_command_write_1988')" prop="desc">
              <el-input
                :maxlength="500"
                show-word-limit
                type="textarea"
                rows="4"
                :placeholder="$t('components_ai_command_tkd_1963')+'\n'+ $t('components_ai_command_write_1989')"
                v-model="dialogForm.desc"
                >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('components_ai_command_write_1990')" prop="length" class="pw_length">
            <el-input
              :maxlength="4"            
              v-model.number="dialogForm.length"
              :placeholder="$t('components_ai_command_write_1991')"
              autocomplete="off">
            </el-input>
            <div class="append">{{$t('components_ai_command_write_1992')}}</div>
          </el-form-item>
          <el-button @click="generateAiContent" :loading="loading" style="width:100%" type="primary" >{{ btnTitle }} </el-button>
          <div v-if="statementShow" class="statement">{{$t('components_ai_command_tkd_1965')}}</div>
        </el-form>

        <div v-show="resultContShow" class="intelligence-content">
          <div class="intelligence-content-top flex_center_center" >
              <div v-if="!loading" @click="importCont" :class=" loading ? 'loading' : ''" class="btn import">{{$t('components_ai_command_tkd_1966')}}</div>
              <div v-if="!loading" @click="copyCont" :class="loading ? 'loading' : ''" class="btn copy">{{$t('components_ai_command_tkd_1967')}}</div>
          </div>
          <div v-html="content" class="intelligence-content-box"></div>
        </div>
      </el-dialog>
</template>

<script>
import i18n from '../../language/index'

import {
  gptUsageCount,  
  splitAiContent,
  getAiCommand
} from "@/api/app.js"
import { fetchEventSource } from '@microsoft/fetch-event-source'
import { getStr } from '@/utils/utils.js'
import Cookies from 'js-cookie'

export default {
  name: "write",
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    command_type: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      labelPosition: 'top',
      role: false,
      error: false,
      resultContShow: false,
      statementShow: true,
      content: '',
      btnTitle:i18n.t('components_ai_command_tkd_1968'),
      dialogForm: {
        type: '',
        subject: '',
        keywords: '',
        desc: '',
        length: '',
      },
      dialogFormRules: {
        keywords: [
          { required: true, message: i18n.t('components_ai_command_tkd_1957')+ this.typeTitle()+i18n.t('components_ai_command_write_1993'), trigger: 'blur' }
        ],
        subject: [
          { required: true, message: i18n.t('components_ai_command_tkd_1957')+ this.typeTitle()+i18n.t('components_ai_command_write_1994'), trigger: 'blur' }
        ],
        length: [
          { required: true, message: i18n.t('components_ai_command_write_1995'), trigger: 'blur' },
          {
            type: 'number',
            max: 3000,
            min: 500,
            message: i18n.t('components_ai_command_write_1996'),
            trigger: 'blur'
          }
        ],
      },

    };
  },
  watch: {
    
  },
  computed:{
    
  },
  methods: {
    typeTitle() {
      let title = ''
      if (this.command_type === 'goods_detail') {
        title = i18n.t('widgets_basic_classification_edit_482');
      } else if (this.command_type === 'article_detail') {
        title = i18n.t('widgets_basic_article_classification_edit_333');
      } else if (this.command_type === 'case_detail') {
        title = i18n.t('widgets_basic_article_classification_edit_334');
      } else if (this.command_type === 'help_detail') {
        title = i18n.t('widgets_basic_article_classification_edit_335');
      }
      return title;
    },
    beforeCloseHandler(){
      if (this.loading) {
        this.$message.error(i18n.t('components_ai_command_tkd_1972'))
        return false;
      }
      if(this.content){
        this.$confirm(i18n.t('components_ai_command_tkd_1973'), i18n.t('view_public_topbar_23'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false
        }).catch(() => { })
      }else{
        this.dialogVisible = false
      }
    },
    closed() {
      this.btnTitle = i18n.t('components_ai_command_tkd_1968');
      this.content = ''
      this.resultContShow = false
      this.statementShow = true
      this.$refs.dialogForm.resetFields()
    },
    async getGptUsageCount() {
      let res = await gptUsageCount()
      if (res.code == 200) {
        if (res.data && res.data.count > 0) {
          this.role = true
        }
      }else{
        this.$message.error(i18n.t('components_ai_command_write_1997'))
      }
    },
    async generateAiContent() {
      let tag = true;
      this.$refs['dialogForm'].validate(valid => {
        tag = valid;
      })
      if(!tag){
        return;
      }
      this.content = ''
      this.loading = true;
      this.btnTitle = i18n.t('components_ai_command_tkd_1974');
      if (!this.role) {
        this.$message.error(i18n.t('components_ai_command_tkd_1975'))
        this.loading = false;
        this.btnTitle = i18n.t('components_ai_command_tkd_1968');
        return false;
      }
      // 获取指令
      const params = Object.assign(this.dialogForm, { 'type': this.command_type })
      let res = await getAiCommand(params)
      if (res.data) {
        this.doSearch(res.data)
      } else {
        this.loading = false;
        this.btnTitle = i18n.t('components_ai_command_tkd_1968');
        this.$message.error(i18n.t('components_ai_command_tkd_1976'))
      }

    },
    doSearch(cont) {
      const _that = this;
      const serverURL = process.env.BASE_Console_Login_Domain + "/ai-article/gpt/history/make"
      const params = {
        "prompt": cont,
        "mode": 1,
        "platform": 6,
      }
      let i=0;
      fetchEventSource(serverURL, {
        method: 'POST',
        headers: {
          "Content-Type": 'application/json',
          "x-token": Cookies.get('X-Token')
        },
        openWhenHidden: true,
        body: JSON.stringify(params),
        onopen(e) {
          _that.resultContShow = true;
          _that.btnTitle = i18n.t('components_ai_command_tkd_1974');
          _that.statementShow = false;
          _that.loading = true
          console.log('连接成功', e)
        },
        onmessage(source) {
          i++;
          _that.toScroll(i)
          if (getStr(source.data).id) {
            // 获取会话上下文id 如果需要保持会话 则需要在下次会话时在params中带上该id参数
            _that.chatId = getStr(source.data).id
          }
          if (getStr(source.data).msg) {
            _that.content += getStr(source.data).msg.replace(/\n/ig, '<br/>')
          }
          if (getStr(source.data).errMsg) {
            _that.loading = false
            _that.error = true
            _that.errMsg = getStr(source.data).errMsg
          }
        },
        onclose(e) {
          _that.loading = false
          _that.btnTitle = i18n.t('components_ai_command_tkd_1977');                  
          console.log('关闭')
        },
        onerror(err) {
          _that.loading = false
          _that.error = true
          console.log('异常', err)
          throw new Error(i18n.t('components_ai_command_tkd_1978'))
        }
      })
    },
    throttle(fn, delay = 90, mustRunDelay = 111) {
      // 高频节流
      let timer = null;
      let startTime;

      return (args) => {
        let stamp = +new Date();
        clearTimeout(timer);
        if (!startTime) startTime = stamp;
        if (stamp - startTime >= mustRunDelay) {
          fn.call(this, args);
          startTime = stamp;
        } else {
          timer = setTimeout(() => {
            fn.call(this, args);
          }, delay);
        }
      };
    },
    toScroll(i) {
      if(i%30 ===0){
        if($(window).height() - ($('.ai-dialog-form.writing').offset().top - $(document).scrollTop()) - $('.ai-dialog-form.writing').height() < 80){
          $('.ai-dialog-form.writing').parent().animate({ scrollTop: "+=80" }, 1000);
        }
        $('.intelligence-content-box').animate({ scrollTop: "+=100" }, 1000);
      }
    },
    copyCont() {
      if (this.loading) {
        return false
      }
      var input = document.createElement('textarea');
      input.value = this.content.replace(/<br\/>/g, '\n');
      document.body.appendChild(input);
      input.select();
      if (input.value) {
        document.execCommand('copy');
        this.$message({
          message: i18n.t('components_ai_command_tkd_1979'),
          type: 'success'
        });
      } else {
        this.$message({
          message: i18n.t('components_ai_command_tkd_1980'),
          type: 'warning'
        });
      }
      document.body.removeChild(input); // 删除input
    },
    importCont(){
      if(this.loading){
        return false
      }
      const _that = this;
      splitAiContent({
        type: this.command_type,
        content: this.content
      }).then(res => {
        if (res.code == 200) {
          if(res.data.summary && res.data.content){
            console.log('res',res);
            _that.$emit('pushCont', res.data)
            _that.$emit('closeDialogForm');
            _that.$refs.dialogForm.resetFields()
            _that.btnTitle = i18n.t('components_ai_command_tkd_1968');
            _that.content = ''
            _that.resultContShow = false
            _that.statementShow = true
            _that.dialogVisible = false
          }
        }
      })
      .catch(err => {
        this.loading = false;
      })
      .finally(() => {
        this.loading = false;
      });
    },
    showDialog(){
      this.dialogVisible = true
    }
  },
  mounted() {
    this.getGptUsageCount()
  }
};
</script>

<style scoped lang="scss">
.subject_icon{
    font-size: 15px;
    position: absolute;
    top: -28px;
    left: 120px;
    cursor: pointer;
    color: #D1D5DC;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_command/write.vue